import Vue from 'vue';
import VueModal from 'vue-js-modal';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import Rollbar from '@ibiquity/dashboard.rollbar';
import VueAnalytics from 'vue-analytics';

import App from './App';
import store from './store';
import router from './router';

const isProduction = process.env.NODE_ENV === 'production';
const gaId = process.env.VUE_APP_GOOGLE_ANALYTICS_ID;

Vue.config.productionTip = false;
Vue.use(VueModal, { componentName: 'vue-modal' });
Vue.use(VueMoment, { moment });
Vue.use(Rollbar);

if (gaId) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router,
    debug: {
      enabled: !isProduction,
      sendHitTask: isProduction,
    },
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  render: h => h(App),
});
